"use client";
import { useEffect, useState } from "react";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import getBlogs from "@/app/lib/getBlogs";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "./style.css";

// import required modules
import { Navigation } from "swiper/modules";
export default function page() {
  const [blogs, setblogs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const fetchedData = await getBlogs();
      setblogs(fetchedData);
    };

    fetchData();
  }, []);
  return (
    <div>
      {/* related article */}
      <div className="w-full p-2 main-related-blog">
        <h3 className="text-[#011826] text-[24px] font-bold proza-font">
          Related Articles
        </h3>
        <Swiper
          slidesPerView={2}
          spaceBetween={30}
          loop={true}
          navigation={true}
          modules={[Navigation]}
          className="mySwiper"
          breakpoints={{
            // When the window width is >= 640px, show 1 slide
            320: {
              slidesPerView: 1,
            },
            // When the window width is >= 640px, show 1 slide
            375: {
              slidesPerView: 1,
            },
            // When the window width is >= 640px, show 1 slide
            475: {
              slidesPerView: 1,
            },
            // When the window width is >= 640px, show 1 slide
            570: {
              slidesPerView: 1,
            },
            // When the window width is >= 640px, show 1 slide
            640: {
              slidesPerView: 1,
            },
            // When the window width is >= 768px, show 2 slides
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            // When the window width is >= 1024px, show 3 slides
            1024: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
          }}
        >
          {blogs &&
            Array.isArray(blogs) &&
            blogs.length >= 0 &&
            blogs?.map((blogs, index) => (
              <SwiperSlide key={index}>
                <div className="flex items-center gap-5">
                  <Link
                    className="flex items-center gap-5"
                    href={`/ReadBlog/${blogs?._id}`}
                  >
                    <img
                      src={blogs?.thumbnail}
                      alt="related blogs"
                      className="w-40 h-20 object-cover"
                    />
                    <h4 className="proza-font font-bold text-lg">
                      {blogs.title}
                    </h4>
                  </Link>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
    </div>
  );
}
